var _excluded = ["initialSelectedValue"],
    _excluded2 = ["openUntilSelected"];

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import "downshift";
import * as React from "react";
import Combobox, { ComboboxMessage, ComboboxOption, ComboboxSectionTitle } from "../Combobox";
import filterTree from "./filterTree";
import getSelectedItem from "./getSelectedItem";
import normalizeInputValue from "./normalizeInputValue";
import { jsx as ___EmotionJSX } from "@emotion/core";

function idAsValue(item) {
  return item ? item.id : null;
}

function displayAsLabel(item) {
  return item ? item.display : "";
}

var Select = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Select, _React$Component);

  function Select(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.onStateChange = function (event) {
      var isOpen = event.isOpen;

      if (isOpen !== undefined) {
        _this.setState({
          isOpen: isOpen
        });
      }

      var onStateChange = _this.props.onStateChange;

      if (onStateChange) {
        onStateChange(event);
      }
    };

    _this.onChange = function (selectedItem) {
      var _ref = _this.props,
          onChange = _ref.onChange,
          onChangeValue = _ref.onChangeValue,
          toValue = _ref.toValue;

      if (onChange) {
        onChange(selectedItem);
      }

      if (onChangeValue) {
        onChangeValue(toValue(selectedItem));
      }
    };

    _this.getFilteredItems = function (comboboxProps) {
      var selectedItem = comboboxProps.selectedItem,
          toLabel = comboboxProps.toLabel;
      var items = _this.props.items;
      var inputValue = normalizeInputValue(comboboxProps.inputValue);
      var label = toLabel(selectedItem);

      if (inputValue === "" || typeof label === "string" && normalizeInputValue(label) === inputValue) {
        return items;
      }

      return filterTree(items, function (item) {
        var treeItemLabel = toLabel(item);
        return typeof treeItemLabel === "string" && normalizeInputValue(treeItemLabel).indexOf(inputValue) !== -1;
      });
    };

    _this.renderMenu = function (comboboxProps) {
      var _ref2 = _this.props,
          asyncSearch = _ref2.asyncSearch,
          minAsyncSearchChars = _ref2.minAsyncSearchChars,
          asyncSearchMessage = _ref2.asyncSearchMessage;
      var toValue = comboboxProps.toValue,
          toLabel = comboboxProps.toLabel,
          inputValue = comboboxProps.inputValue;

      if (asyncSearch && inputValue != null && inputValue.length < minAsyncSearchChars) {
        return ___EmotionJSX(ComboboxMessage, null, asyncSearchMessage);
      }

      var items = _this.getFilteredItems(comboboxProps);

      var menu = [];
      var index = 0;

      var renderItem = function renderItem(item) {
        if (item.children != null) {
          var label = toLabel(item);
          var key = toValue(item) || undefined;

          if (!key) {
            if (typeof label === "string") {
              key = label;
            }
          }

          menu.push(___EmotionJSX(ComboboxSectionTitle, {
            key: key
          }, label));
          item.children.forEach(renderItem);
        } else {
          menu.push(___EmotionJSX(ComboboxOption, _extends({}, comboboxProps, {
            key: toValue(item) || undefined,
            item: item,
            index: index
          }), _this.props.renderOption == null ? void 0 : _this.props.renderOption(_extends({
            item: item,
            index: index
          }, comboboxProps))));
          index += 1;
        }
      };

      items.forEach(renderItem);
      return menu;
    };

    _this.state = {
      isOpen: false
    };

    _this.triggerOnChangeFromDefaultSelectedValue(props);

    return _this;
  }

  var _proto = Select.prototype;

  _proto.triggerOnChangeFromDefaultSelectedValue = function triggerOnChangeFromDefaultSelectedValue(_ref3) {
    var initialSelectedValue = _ref3.initialSelectedValue,
        props = _objectWithoutPropertiesLoose(_ref3, _excluded);

    if (props.selectedItem != null) {
      return;
    }

    var selectedItem = getSelectedItem(_extends({}, props, {
      selectedValue: initialSelectedValue
    }));

    if (selectedItem) {
      this.onChange(selectedItem);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        openUntilSelected = _this$props.openUntilSelected,
        props = _objectWithoutPropertiesLoose(_this$props, _excluded2);

    var selectedItem = getSelectedItem(this.props);
    var isOpen = this.state.isOpen;

    if (openUntilSelected && !this.props.disabled && !selectedItem) {
      isOpen = true;
    }

    return ___EmotionJSX(Combobox, _extends({}, props, {
      isOpen: isOpen,
      selectedItem: selectedItem,
      onStateChange: this.onStateChange,
      onChange: this.onChange
    }), this.renderMenu);
  };

  return Select;
}(React.Component);

Select.defaultProps = {
  allowClear: false,
  toLabel: displayAsLabel,
  toValue: idAsValue,
  disabled: false,
  openUntilSelected: false,
  asyncSearch: false,
  minAsyncSearchChars: 2,
  asyncSearchMessage: "Type to search",
  renderOption: function renderOption(_ref4) {
    var item = _ref4.item,
        toLabel = _ref4.toLabel;
    return toLabel(item);
  }
};
export { Select as default };